import { apiGwConfig, apiHost } from 'apiClients/api.config';
import { OAuth20Api } from 'apiClients/msc-api-gateway/oauth2/client/oauth20-api';
import { TokenDataMapper } from './Token.dataMapper';
import { TokenService } from './Token.service';

const apiClient = new OAuth20Api(apiGwConfig, apiHost);
const dataMapper = new TokenDataMapper(apiClient);
export const tokenService = new TokenService(dataMapper);
